import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=8625f6ea&scoped=true"
import script from "./MemberProfile.vue?vue&type=script&lang=js"
export * from "./MemberProfile.vue?vue&type=script&lang=js"
import style0 from "./MemberProfile.vue?vue&type=style&index=0&id=8625f6ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8625f6ea",
  null
  
)

export default component.exports